import React from 'react';
import { useNavigate } from "react-router-dom";
import location from '../assets/location.svg';
import calendar from '../assets/calendar.svg';
import userIcon from '../assets/user-icon.svg';

interface LeadProps {
    id: number;
    raw_lead_id: number;
    cust_name: string;
    bhk: string;
    city: string;
    raw_lead_created_at: string;
    status: string;
    time: string;
    raw_leads_budget_max: number;
    raw_leads_budget_min: number;
    raw_leads_configuration: string;
    raw_leads_property_type: string;
    raw_leads_buying_location: string;
    customer_address: string;
    raw_leads_remarks: string;
    voice_note: string;
}

const LeadCard: React.FC<LeadProps> = ({
    id,
    raw_lead_id,
    cust_name,
    bhk,
    city,
    raw_lead_created_at,
    status,
    time,
    raw_leads_budget_max,
    voice_note,
    raw_leads_budget_min,
    raw_leads_configuration,
    raw_leads_property_type,
    raw_leads_buying_location,
    customer_address,
    raw_leads_remarks
}) => {
    const navigate = useNavigate();

    const handleLeadClick = () => {
        if (status === "notQualify") {
            navigate(`/rawlead/${raw_lead_id}`, {
                state: {
                    raw_lead_id,
                    cust_name,
                    bhk,
                    city,
                    raw_leads_budget_max,
                    raw_leads_budget_min,
                    raw_leads_configuration,
                    raw_leads_property_type,
                    raw_leads_buying_location,
                    customer_address,
                    raw_leads_remarks,
                    voice_note,
                    status
                }
            });
            window.location.href = `/rawlead/${raw_lead_id}`;
        } else {
            navigate(`/lead/${id}`, {
                state: {
                    id,
                    raw_lead_id,
                    cust_name,
                    bhk,
                    city,
                    raw_leads_budget_max,
                    raw_leads_budget_min,
                    raw_leads_configuration,
                    raw_leads_property_type,
                    raw_leads_buying_location,
                    customer_address,
                    raw_leads_remarks,
                    voice_note,
                    status
                }
            });
            window.location.href = `/lead/${id}`;
        }
    };

    // Determine which ID to display
    const displayId = (status === "notQualify" ) ? raw_lead_id : id;
    const displayIdLabel = (status === "notQualify") ? "Raw Lead ID" : "Lead ID";

    return (
        <div className="lead-card" style={{ cursor: "pointer" }} onClick={handleLeadClick}>
            <div className="left">
                <div className="avatar-test">
                    <img src={userIcon} alt='lead-user-icon' />
                </div>
                <div className="info">
                    <h4>{cust_name}</h4>
                    <p className="sub-text-test">{displayIdLabel}: {displayId}</p>
                    <p className="icon-text">
                        <img src={location} alt="" /> {city}
                    </p>
                    <p className="icon-text">
                        <img src={calendar} alt="" /> Added: {raw_lead_created_at}
                    </p>
                </div>
            </div>

            <div className="right">
                <span className={`badge ${status === 'active' ? 'active-badge' : 
                    status === 'invalid' ? 'invalid-badge' : 'notqualify-badge'}`}>
                    {status === 'active' ? 'Active' : 
                     status === 'invalid' ? 'Invalid' : 'Not Qualify'}
                </span>
                <p className="time">{time}</p>
            </div>
        </div>
    );
};

export default LeadCard;